/**
 * BatchGeoMarkerMeasure generates a marker for user's to drag that will
 * calculate distance from that marker to every marker the user had added during
 * the map creation. I'll show the distances in the Distance column. For a
 * visual it will also draw a line from the draggable marker to all existing
 * markers.
 */
(function () {
  function BatchGeoMarkerMeasure() {
    // var shortcuts
    var bgt = window.batchGeoTableMap.batchGeoTable;
    var draggableMarker = new BatchGeoMarkerMeasureMarker();
    var measurePolylines = new BatchGeoMarkerMeasurePolylines();
    // var bgtDisplayData = bgt.getDisplayData();

    /**
     * Looks for the distance column by looking for the string of "Distance" in
     * the columns array and if found returns the index of that column.
     * @return {number} Will give you -1 if no distance column or >=0 if found
     */
    var getDistanceColumnIndex = function () {
      return bgt.data.columns.indexOf("Distance");
    };

    /**
     * Sorts the BatchGeoTable data based on on the distance columns
     * @return {undefined}
     */
    var sortRows = function () {
      BatchGeoStore.dispatch({
        type: "HEADER_SORT_SET",
        state: 0,
        index: getDistanceColumnIndex(),
      });
    };

    /**
     * Draws polylines from the measuring marker to each of the other markers
     * the user created. This feature can be turned on or off by setting the
     * enablePolylines property to true/false in the MarkerMeasure store.
     *
     * @param {boolean} [isUpdate] If true, it updates the existing polylines.
     * If false it creates new polylines
     * @return {undefined}
     */
    var createOrUpdatePolylines = function (isUpdate) {
      if (!BatchGeoStore.getState().MarkerMeasure.enabled) return;

      var markerMeasureState = BatchGeoStore.getState().MarkerMeasure;
      var selected =
        window.batchGeoTableMap.batchGeoTable.RowSelect.getSelectedRows().map(
          (i) => i.id,
        );

      //exit early if we don't have a valid set of markers to highlight
      var markerCount = window.batchGeoGoogleMapsMarker.getMarkerCount();
      var validSelection =
        selected.length > 0 &&
        selected.length < markerMeasureState.polylineLimit;
      if (!validSelection) selected = [];

      //Collect data for iteration
      var markers = window.batchGeoGoogleMapsMarker.getMarkersAsObject();
      var polylines = measurePolylines.getPolylines();
      var distanceMarkerPosition = markerMeasureState.position;

      //if there is no selection, use all markers
      if (
        selected.length == 0 &&
        markerCount < markerMeasureState.polylineLimit
      )
        selected = Object.keys(markers);

      //Remove polylines that arn't selected
      Object.keys(polylines).forEach((i) => {
        if (!selected.some((id) => id == i)) {
          if (polylines[i]) measurePolylines.removePolyline(i);
          return;
        }
      });

      //update/create selected polylines
      selected.forEach(function (markerId) {
        // If every marker has a path recorded we can simply update them
        if (isUpdate && polylines[markerId]) {
          var path = polylines[markerId].getPath();
          path.removeAt(1);
          path.push(distanceMarkerPosition);
          measurePolylines.updatePolyline(markerId, polylines[markerId]);
        }
        // For every marker that does not have a path recorded we need to create
        // a polyline for it
        else {
          // Find the marker <=> row match in the two collections
          var markerForRow = markers[markerId];
          measurePolylines.addPolyline(
            [markerForRow.position, distanceMarkerPosition],
            markerId,
          );
        }
      });
    };

    /**
     * This will update the distance column with the distances of each markers
     * relation to the draggable marker. It will also render all the polylines
     * that go from the draggable marker to the user created markers.
     *
     * @return {undefined}
     */
    var updateDistanceColumn = function () {
      var mapsManager = window.batchGeoGoogleMapsManager;
      var distanceMarkerPosition =
        BatchGeoStore.getState().MarkerMeasure.position;

      var mapRS = bgt.options.data.mapRS;
      var selected =
        window.batchGeoTableMap.batchGeoTable.RowSelect.getSelectedRows().map(
          (i) => i.id,
        );
      bgt.updateColumn(
        mapRS.map(function (row, index) {
          //clear unselected markers, TODO: find a list of rows with distances to check for removal rather than parsing the whole list.
          if (selected.length > 0 && !selected.some((id) => id == index))
            return "";
          // As long as the lat/lng is good we can measure it
          if (BatchGeo.goodLatLon(row.lt, row.ln)) {
            var distance = mapsManager.getDistanceBetweenMarkers(
              new google.maps.LatLng(row.lt, row.ln),
              distanceMarkerPosition,
            );

            return distance;
          }
          // If it's not just return an empty string for an empty cell
          else {
            return "0";
          }
        }),
        getDistanceColumnIndex(),
      );
      bgt.rebuildRows();
    };

    /**
     * Manages setting the events on the marker such as drag, dragstart and
     * dragend. The events here never need to be removed because the marker
     * itself will get destroyed.
     */
    var setEventsOnMarker = function () {
      BatchGeoStore.addListener("RowSelect", "selection", () => {
        createOrUpdatePolylines(true);
        updateDistanceColumn();
      });
      BatchGeoStore.addListener(
        "MarkerMeasure",
        function (nextState, prevState) {
          return (
            nextState.isDragging &&
            !_.isEqual(nextState.dragOriginPoint, prevState.dragOriginPoint)
          );
        },
        function (nextState) {
          BatchGeoStore.dispatch({
            type: "MARKER_MEASURE_RENDER_MARKER",
            renderMarker: false,
          });
          BatchGeoStore.dispatch({
            type: "MARKER_MEASURE_SET_POSITION",
            position: {
              lat: nextState.position.lat(),
              lng: nextState.position.lng(),
            },
          });
          createOrUpdatePolylines(true);
        },
      );

      BatchGeoStore.addListener(
        "MarkerMeasure",
        "isDragging",
        function (nextState) {
          if (nextState.isDragging === false) {
            updateDistanceColumn();
          }
        },
      );
    };

    /**
     * Enables MarkerMeasure by generating the draggable marker, adding the
     * events for that marker, and updating the distance column.
     *
     * @param {object} The current state of MarkerMeasure
     * @return {undefined}
     */
    var enable = function (currentState) {
      draggableMarker.createMarker(currentState.position);
      setEventsOnMarker();
      createOrUpdatePolylines();
      updateDistanceColumn();
      sortRows();
    };

    /**
     * Disables the tool by deleting the draggable marker (which deletes the
     * events associated with that marker) and removing all the polylines.
     * @return {undefined}
     */
    var disable = function () {
      draggableMarker.clearMarker();
      measurePolylines.clearPolylines();

      bgt.updateColumn(
        bgt.options.data.mapRS.map(function (row) {
          if (BatchGeo.goodLatLon(row.lt, row.ln)) {
            return row.distance;
          } else {
            return "";
          }
        }),
        getDistanceColumnIndex(),
      );

      sortRows();
    };

    // Listener to handle the disable and enabling of the tool and pass the new
    // and old state to enable/disable functions
    BatchGeoStore.addListener(
      function (state) {
        return state.MarkerMeasure;
      },
      function (newState, oldState) {
        return newState.enabled !== oldState.enabled;
      },
      function (newState) {
        newState.enabled ? enable(newState) : disable();
      },
    );

    // Listener to redraw the polylines when the filtered markers have changed
    BatchGeoStore.addListener(
      "MarkerLegend",
      function (newState, oldState) {
        return (
          newState.filteredMarkers.toString() !==
          oldState.filteredMarkers.toString()
        );
      },
      function () {
        if (!BatchGeoStore.getState().MarkerMeasure.enabled) return false;
        // Remove all the lines from the map whenever there is a filter update
        measurePolylines.clearPolylines();

        // Finally we can re-render the polylines
        createOrUpdatePolylines();
      },
    );
  }

  window.BatchGeoMarkerMeasure = BatchGeoMarkerMeasure;
})();
